import { render, staticRenderFns } from "./widgetColumns.vue?vue&type=template&id=9bb87f6e&scoped=true"
import script from "./widgetColumns.vue?vue&type=script&setup=true&lang=js"
export * from "./widgetColumns.vue?vue&type=script&setup=true&lang=js"
import style0 from "./widgetColumns.vue?vue&type=style&index=0&id=9bb87f6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb87f6e",
  null
  
)

export default component.exports